export const UPDATE_ROLE_ROWS = 'UPDATE_ROLE_ROWS';
export const UPDATE_USERINROLE_ROWS = 'UPDATE_USERINROLE_ROWS'
export const SELECTED_USERINROLE_ROWS = 'SELECTED_USERINROLE_ROWS'
